
import { defineComponent, reactive, computed, getCurrentInstance } from 'vue';

export default defineComponent({
  setup(_, ctx) {
    const { proxy } = getCurrentInstance() as { proxy: any }

    const state = reactive({
      activeLeft: 0,
    });

    const handleFollowClick = () => {
      ctx.emit('headerFollowClick')
    };

    const handleClickSearch = () => {
      const pathName = encodeURIComponent(window?.location?.pathname)
      proxy.$router.push({
        path: '/discover',
        query: {
          ...proxy.$route.query,
          page_source: pathName
        }
      });
    }

    const slideStyle = computed(() => {
      return {
        left: `${state.activeLeft}px`,
      };
    });


    return {
      slideStyle,
      handleFollowClick,
      handleClickSearch,
    };
  },
});
